import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { HiOutlineLightningBolt, HiChevronUp, HiChevronDown } from 'react-icons/hi'
import './ActivityTicker.css'

// Simple relative time helper
function getRelativeTime(dateString) {
    const date = new Date(dateString)
    const now = new Date()
    const diffInSeconds = Math.floor((now - date) / 1000)

    if (diffInSeconds < 60) return 'just now'
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`
    return date.toLocaleDateString()
}

const ActivityTicker = ({ activities = [], loading = false }) => {
    const [isPaused, setIsPaused] = useState(false)
    const [isVisible, setIsVisible] = useState(true)

    if (loading) return null // animate in or show nothing while loading
    if (!activities || activities.length === 0) return null

    // Duplicate list to ensure smooth infinite scroll
    const tickerItems = [...activities, ...activities, ...activities]

    return (
        <div className={`activity-ticker-wrapper ${isVisible ? 'visible' : 'hidden'}`}>
            <div
                className="activity-ticker-container"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
            >
                <div className="ticker-label">
                    <HiOutlineLightningBolt />
                    <span>Live Activity</span>
                </div>

                <div className="ticker-mask">
                    <div
                        className={`ticker-track ${isPaused ? 'paused' : ''}`}
                        style={{
                            // Adjust duration based on item count to ensure consistent speed
                            animationDuration: `${Math.max(20, activities.length * 5)}s`
                        }}
                    >
                        {tickerItems.map((item, index) => (
                            <div key={`${item.created_at}-${index}`} className="ticker-item">
                                <span className="ticker-text">
                                    New vote: <strong>{item.choice_text}</strong> on <span>{item.poll_title}</span>
                                </span>
                                <span className="ticker-meta">
                                    • {getRelativeTime(item.created_at)}
                                </span>
                                {item.poll_short_code && (
                                    <Link to={`/poll/${item.poll_short_code}`} className="ticker-link-overlay" aria-label="View poll" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <button
                className="ticker-toggle-btn"
                onClick={() => setIsVisible(!isVisible)}
                title={isVisible ? "Hide activity" : "Show activity"}
            >
                {isVisible ? <HiChevronUp /> : <HiChevronDown />}
            </button>
        </div>
    )
}

export default ActivityTicker
